/**
 * Modify 'push' and 'access' callbacks to store the token on session storage before returning it
 *
 * @param tokenType The type of the token
 * @param tokenCallback The original token callback
 * @returns The modified callback that stores the token on session storage
 */
export function buildCachedTokenCallback(tokenType, tokenCallback) {
    if (!isSessionStorageDefined())
        return tokenCallback;
    return async () => {
        const token = await tokenCallback();
        sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem(sessionStorageKey[tokenType], token);
        return token;
    };
}
/**
 * Modify odsp token callbacks to store the token on session storage before returning it
 *
 * @param tokenCallback The original token callback
 * @returns The modified callback that stores the token on session storage
 */
export function buildCachedOdspTokenCallback(tokenCallback) {
    if (!tokenCallback || !isSessionStorageDefined())
        return tokenCallback;
    return async (odspSiteDomain) => {
        const token = await tokenCallback(odspSiteDomain);
        sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem(sessionStorageKey['odsp'], token);
        return token;
    };
}
/**
 * Sets a flag in session storage denoting the type of MFS Client used.
 *
 * @param value The key representing the type of client `odsp` or `tiny`.
 */
export function storeMfsClientType(value) {
    if (!isSessionStorageDefined())
        return;
    sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem(sessionStorageKey.type, value);
}
/**
 * Stores the document id in session storage for Tinylicious Clients.
 *
 * @param id The id of the document running on a Tinylicious Client.
 */
export function storeMfsClientDocumentId(id) {
    if (!isSessionStorageDefined())
        return;
    sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem(sessionStorageKey.document, id);
}
export const sessionStorageKey = {
    type: 'mfsClient-type',
    document: 'mfsClient-id',
    access: 'mfsClient-access-token',
    push: 'mfsClient-push-channel-access-token',
    odsp: 'mfsClient-odsp-access-token',
};
export const orderedSessionKeys = [
    sessionStorageKey.type,
    sessionStorageKey.document,
    sessionStorageKey.access,
    sessionStorageKey.push,
    sessionStorageKey.odsp,
];
const isSessionStorageDefined = () => {
    return typeof sessionStorage !== 'undefined' && typeof sessionStorage != null;
};
//# sourceMappingURL=sessionStorageUtility.js.map